import * as React from 'react'
import styled from 'styled-components'

import { Icon } from '../Icon'
import { SpecificIconProps } from '../types'
import { lightweight, standalone, SymbolProps } from '../../spritesheetUtils'

const ID = 'youtube-third-party-glyph-icon'

export function YoutubeSymbol({ id = ID, ...props }: SymbolProps): React.ReactElement<SymbolProps> {
  return (
    <symbol {...props} id={id}>
      <path d="m8.797 10.838-.001-6.125 5.764 3.073-5.763 3.052Zm12.657-7.187s-.209-1.502-.848-2.163c-.81-.868-1.72-.872-2.138-.923-2.985-.221-7.463-.221-7.463-.221h-.01s-4.478 0-7.463.22c-.418.052-1.326.056-2.138.924-.639.661-.848 2.163-.848 2.163S.333 5.416.333 7.18v1.654c0 1.765.213 3.529.213 3.529s.208 1.502.848 2.163c.812.869 1.878.842 2.353.932 1.706.167 7.254.22 7.254.22s4.482-.007 7.467-.229c.417-.05 1.326-.054 2.138-.924.639-.66.848-2.163.848-2.163s.213-1.763.213-3.529V7.18c0-1.763-.213-3.529-.213-3.529v.001Z" />
    </symbol>
  )
}

const YoutubeStandaloneContent = standalone(YoutubeSymbol, ID)

export const Youtube = styled(function YoutubeStandaloneComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="social-youtube" viewBox="0 -3 24 21">
      <YoutubeStandaloneContent />
    </Icon>
  )
})``

export const YoutubeLightweight = styled(function YoutubeComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="social-youtube" viewBox="0 -3 24 21">
      {lightweight(ID)}
    </Icon>
  )
})``
